<template>
  <li role="presentation"><hr role="separator" aria-orientation="horizontal" class="dropdown-divider"></li>
</template>

<script>
  export default {
    name: 'BaseDropdownDivider'
  };
</script>
